export default __webpack_public_path__ + "static/media/preview-screen.ef07cca9.png";